module.exports = __webpack_public_path__ + "static/media/LV1.b6c17f80.png";